import { useAsync } from '@tiger/hooks';
import Toast from '@tiger/toast';
import { Button, Form, Switch } from 'antd';
import React from 'react';
import { $Formutil, FormItem, useForm, withForm } from 'react-antd-formutil';
import { CardButtonWrap } from 'components/Card';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import { ModalHandler } from 'components/Modal';
import APP from 'stores/APP';
import API from 'utils/API';
import http from 'utils/http';

import './style.scss';

interface PositionSwitchProp {
    $formutil: $Formutil;
}

const PositionSwitch: React.FC<PositionSwitchProp & Partial<ModalHandler>> = ({ dismiss, close }) => {
    const $formutil = useForm();
    const [state, getStatus] = useAsync(
        () => http.get(API.OAUTH.otp.status()),
        state => {
            if (state.data) {
                $formutil.$setValues(state.data.data.verify);
            }
        }
    );

    const cancel = () => {
        dismiss?.('cancel');

        APP.trackEvent('安全中心', '两步验证_位置', '位置_取消');
    };

    const submit = async () => {
        APP.trackEvent('安全中心', '两步验证_位置', '位置_确定');

        const { $params } = $formutil;

        const result: string[] = [];

        Object.keys($params).forEach(key => {
            if ($params[key] === 1) {
                result.push(key);
            }
        });

        if (result.length === 0) {
            Toast.show(__('两步验证你需要至少在一个位置启用，请返回修改'));

            return;
        }

        close?.(result.join(','));
    };

    const handleChange = (value, name) => {
        if (value) {
            APP.trackEvent('安全中心', '两步验证_位置', `位置_${name}on`);
        } else {
            APP.trackEvent('安全中心', '两步验证_位置', `位置_${name}off`);
        }
    };

    const { loading, error } = state;

    if (loading) {
        return <Loading tip={__('加载中...')} />;
    }

    if (error) {
        return <ErrorBox error={error} onClick={getStatus} />;
    }

    return (
        <Form labelAlign="left" layout="horizontal" colon={false} className="fa-position-switch" onFinish={submit}>
            <FormItem
                $onFieldChange={value => handleChange(value, '登录')}
                itemProps={{ label: __('登录') }}
                name="signin"
                checked={1}
                unchecked={0}>
                <Switch />
            </FormItem>
            <FormItem
                $onFieldChange={value => handleChange(value, '交易')}
                itemProps={{ label: __('交易') }}
                name="trade"
                checked={1}
                unchecked={0}>
                <Switch />
            </FormItem>
            <CardButtonWrap>
                <Button onClick={cancel}>{__('取消')}</Button>
                <Button type="primary" htmlType="submit">
                    {__('确认')}
                </Button>
            </CardButtonWrap>
        </Form>
    );
};

export default withForm(PositionSwitch);
